import { create } from 'zustand';
import type { OrientationPose } from '../utils/orientation';

interface OrientationThumbState {
  data: Partial<Record<OrientationPose, string>>;
  setData: (data: Partial<Record<OrientationPose, string>>) => void;
  clear: () => void;
}

export const useOrientationThumbStore = create<OrientationThumbState>((set) => ({
  data: {},
  setData: (data) => set({ data }),
  clear: () => set({ data: {} }),
}));
